import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AbstractRequestDto } from '@app/core/dto/abstract-request.dto';
import { ModuleType } from '@app/core/enums/module-type.enum';
import { StringUtils } from '@app/core/utils/string.utils';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private _http: HttpClient = inject(HttpClient);

  getPagefetchData(
    module: ModuleType,
    body: AbstractRequestDto,
  ): Observable<any> {
    const url: string = this._getUrl(module, 'page/fetch');
    return this._http.post(url, body);
  }

  getActionData(module: ModuleType, body: AbstractRequestDto): Observable<any> {
    const url: string = this._getUrl(module, 'action');
    return this._http.post(url, body);
  }

  getPartialActionData(
    module: ModuleType,
    body: AbstractRequestDto,
  ): Observable<any> {
    const url: string = this._getUrl(module, 'partial/action');
    return this._http.post(url, body);
  }

  callVerificationApi(body: any): Observable<any> {
    return this._http.post('/api/entity-verification', body);
  }

  callFileUploadApi(body: any): Observable<any> {
    return this._http.post('/api/storage/upload', body);
  }

  callFileDeleteApi(body: any): Observable<any> {
    return this._http.post('/api/storage/delete', body);
  }

  getUser(body: any): Observable<any> {
    const url: string = this._getUrl(ModuleType.USER, 'me');
    return this._http.post(url, body);
  }

  getCreditStatus(body: any): Observable<any> {
    const url: string = this._getUrl(ModuleType.USER, 'credit/status');
    return this._http.post(url, body);
  }

  getPromosData(body: any): Observable<any> {
    return this._http.post("/api/promo/page/fetch", body);
  }

  async getCloudflareHeaders() {
    const url: string = 'https://location.industrybuying.com';
    const response = await fetch(url, { method: 'GET' });
    const data = await response.json();
    return data;
  }

  refreshPage(pageUrl: string) {
    const body = { pageUrl };
    return this._http.post(
      'https://prerender.devops-806.workers.dev/api/cache/purge',
      body,
    );
  }

  getAutoSuggest(payload: any): Observable<any> {
    return this._http.post('/api/search/autosuggest/', payload);
  }

  private _getUrl(module: ModuleType, endpoint: string): string {
    let urlVariable: string;
    switch (module) {
      case ModuleType.CATALOG:
        urlVariable = 'catalog';
        break;

      case ModuleType.CHECKOUT:
        urlVariable = 'checkout';
        break;

      case ModuleType.USER:
        urlVariable = 'users';
        break;

      case ModuleType.ORDER:
        urlVariable = ModuleType.ORDER;
        break;
      case ModuleType.NPS:
        urlVariable = ModuleType.NPS;
        break;
      case ModuleType.ARTICLES:
        urlVariable = 'articles';
        break;

      default:
        urlVariable = 'catalog';
        break;
    }
    return StringUtils.format('/api/{0}/{1}', urlVariable, endpoint);
  }
}
